import React, { useEffect, useState } from 'react';
import { Modal, Typography, Table, Tabs, List, Button, Input, notification } from 'antd';
import { PlusOutlined, MinusOutlined, CloseOutlined, CheckOutlined, EditOutlined, AlignLeftOutlined } from '@ant-design/icons';
import "../../css/generatedpools.css";
import { Footer } from 'antd/es/layout/layout';
import cbRedIcon from "../../assets/icons/pooling/cb-red.svg";
import cbGreenIcon from "../../assets/icons/pooling/cb-green.svg";
import infoIcon from "../../assets/icons/auto-pooling/info.svg";
import tokenCubeIcon from "../../assets/icons/auto-pooling/tokenCube.svg";
import vectorrightIcon from "../../assets/icons/auto-pooling/rightvector.svg";
import { manualPriceBreakDown, updateManualPriceBreakDown, updateManualPriceBreakDownData } from "../../features/Pooling/PoolingSlice";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

notification.config({
  zIndex: 1500,
});

const addThousandSeparator = (value) => {
  const number = parseFloat(value);

  if (isNaN(number)) {
    return '';
  }

  return number.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};


const removeLastDictionary = (manualPriceBreakDown) => {
  return manualPriceBreakDown?.length > 0 ? manualPriceBreakDown?.slice(0, -1) : manualPriceBreakDown;
};

const getLastDictionary = (manualPriceBreakDown) => {
  return manualPriceBreakDown.length > 0 ? manualPriceBreakDown[manualPriceBreakDown.length - 1] : null;
};

const DistributionModal = ({ handleInitiatePool, isModalVisible, handleCancel, setIsModalVisible, redirectedPoolId }) => {
  const [filterType, setFilterType] = useState('all'); // State to manage filter
  const [isFinalModalVisible, setFinalModalVisible] = useState(false);
  const { manualPriceBreakDown } = useSelector((state) => state.pooling);
  const [selectedPool, setSelectedPool] = useState(null);
  const [editingRow, setEditingRow] = useState(null);
  const [contributionMap, setContributionMap] = useState({});
  const [hasEdited, setHasEdited] = useState(false);
  const [localValue, setLocalValue] = useState(null);
  const [localInput, setLocalInput] = useState({});

  console.log("action.my",manualPriceBreakDown);

  useEffect(() => {
    const data = filterVessels(filterType, removeLastDictionary(manualPriceBreakDown));

    const firstcontributionmap = {};

    data.forEach((item) => {
      firstcontributionmap[item.token_id] =
        item.cb_wants_to_sell >= 0 ? Math.trunc(parseFloat(item.cb_consumed))?.toFixed(6) : item.cb_wants_to_sell?.toFixed(6);
    });

    setContributionMap(firstcontributionmap);
  }, [manualPriceBreakDown]);


  const handleContributionChange = (inputVal, record) => {
    // Save the typed string directly
    setLocalInput((prev) => ({
      ...prev,
      [record.token_id]: inputVal,
    }));

    const numericVal = parseFloat(inputVal);

    if (!isNaN(numericVal) && (numericVal * 10 ** 6 <= record.cb_wants_to_sell)) {
      setContributionMap((prev) => ({
        ...prev,
        [record.token_id]: numericVal * 10 ** 6,
      }));
    }
  };




  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [scrollHeight, setScrollHeight] = useState(
    window.innerWidth < 1600 ? `${Math.min(window.innerHeight * 0.55, window.innerHeight)}px` : "66vh"
  );

  useEffect(() => {
    const handleResize = () => {
      setScrollHeight(
        window.innerWidth < 1600 ? `${Math.min(window.innerHeight * 0.55, window.innerHeight)}px` : "66vh"
      );
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const handleCloseModal = () => {
    setIsModalVisible(false);
    setFinalModalVisible(false);
    window.location.reload();
  }
  const handleConfirm = () => {
    setFinalModalVisible(false);
    navigate("/poolingHistory");
  };

  const handleFilterChange = (type) => {
    setFilterType(type);
  };

  const filterVessels = (filterType, pool) => {

    // Ensure pool is an array
    const poolArray = Array.isArray(pool) ? pool : Object.values(pool);
    // console.log("poolpool", poolArray,filterType);
    if (filterType === "all") {
      return poolArray;
    } else {
      return poolArray.filter((vessel) => vessel.type == filterType);
    }
  };

  const columns = [
    {
      title: 'Token ID',
      dataIndex: 'token_id',
      key: 'token_id',
      align: "center",
      width: 160,
      render: (text) => (
        <div className="generated-pool-token vessel-value">
          <img src={tokenCubeIcon} alt="Token Cube" /> {text}
        </div>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'type',
      key: 'type',
      width: 90,
      align: "center",
      render: (text) => (
        <span style={{ color: text === 'deficit' ? '#FB2F2F' : '#0CC876' }}>{text?.charAt(0).toUpperCase() + text?.slice(1)}</span>
      ),
    },
    {
      title: <>Compliance Balance <br /> (CB)</>,
      dataIndex: 'cb_wants_to_sell',
      key: 'cb_wants_to_sell',
      align: "center",
      width: 190,
      render: (value) => {
        const formattedValue = parseFloat(
          (Math.trunc(parseFloat(value / 10 ** 6) * 10 ** 6) / 10 ** 6)?.toFixed(6)
        );
        return (
          <div className="vessel-value" style={{ color: formattedValue < 0 ? "#FB2F2F" : "#0CC876" }}>
            <img width={25} src={formattedValue < 0 ? cbRedIcon : cbGreenIcon} alt="CB Icon" />
            {Math.abs(formattedValue)?.toFixed(6)}
          </div>
        );
      },
    },
    {
      title: <>Contribution <br /> (CB)</>,
      dataIndex: 'cb_consumed',
      key: "cb_consumed",
      align: "center",
      render: (_, record) => {
        const isEditable = editingRow === record.token_id;
        const value =
          contributionMap[record.token_id] ?? Math.min(record?.cb_wants_to_sell >= 0 ? record?.cb_wants_to_sell : record?.cb_consumed, 0);
        // console.log("recordedd", value)

        const formattedValue = (Math.trunc(value / 10 ** 6 * 10 ** 6) / 10 ** 6);

        if (record.cb_wants_to_sell < 0) return (<div className="vessel-value" style={{ color: formattedValue < 0 ? "#FB2F2F" : "#0CC876" }}>
          <img width={25} src={formattedValue < 0 ? cbRedIcon : cbGreenIcon} alt="CB Icon" />
          {Math.abs(formattedValue)?.toFixed(6)}
        </div>);

        return (
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
            {isEditable ? (
              <>
                <Input
                  type="text"
                  inputMode="decimal"
                  value={localInput[record.token_id] ?? ""}
                  style={{ width: 100 }}
                  onChange={(e) =>
                    handleContributionChange(e.target.value, record)
                  }
                />
                <Button
                  icon={<CheckOutlined />}
                  size="small"
                  onClick={() => setEditingRow(null)}
                />
              </>
            ) : (
              <>
                <div className="vessel-value" style={{ color: formattedValue < 0 ? "#FB2F2F" : "#0CC876" }}>
                  <img width={25} src={formattedValue < 0 ? cbRedIcon : cbGreenIcon} alt="CB Icon" />
                  {Math.abs(formattedValue)?.toFixed(6)}
                </div>
                {positiveCBWantsToSellCount > 1 && filterType === "all" ? (
                  <Button
                    icon={<EditOutlined />}
                    size="small"
                    onClick={() => {
                      setHasEdited(true);
                      setEditingRow(record.token_id);
                    }}
                  />
                ) : null}
              </>
            )}
          </div>
        );
      },
    },
    {
      title: <>Remaining <br /> (CB)</>,
      dataIndex: 'total_value',
      key: "remaining_cb",
      align: "center",
      render: (_, record) => {
        const rawCB = parseFloat(record.cb_wants_to_sell);
        const rawContribution = parseFloat(contributionMap[record.token_id] ?? 0);

        // Scale both down
        const cb = rawCB / 10 ** 6;
        const contribution = rawContribution / 10 ** 6;

        // Subtract and truncate precision
        const remaining = parseFloat(
          (Math.trunc((cb - contribution) * 10 ** 6) / 10 ** 6).toFixed(6)
        );

        return (
          <div className="vessel-value" style={{ color: remaining < 0 ? "#FB2F2F" : "#0CC876" }}>
            <img width={25} src={remaining < 0 ? cbRedIcon : cbGreenIcon} alt="CB Icon" />
            {Math.abs(remaining).toFixed(6)}
          </div>
        );
      },
    },
    {
      title: <>Final Price <br /> (€)</>,
      dataIndex: 'total_value',
      key: 'total_value',
      align: "center",
      render: (value) => (
        <div className="vessel-value" style={{ color: parseFloat(value) < 0 ? "#678DFF" : "#678DFF" }}>
          {/* <img width={25} src={parseFloat(value) < 0 ? cbRedIcon : cbGreenIcon} alt="Final Price Icon" /> */}
          {addThousandSeparator((value / (10 ** 6)))}
        </div>
      ),
    },
  ];

  const data = filterVessels(filterType, removeLastDictionary(manualPriceBreakDown));
  const positiveCBWantsToSellCount = data.filter(item => item.cb_wants_to_sell > 0).length;

  const pool_closed_At = Math.abs(
    data
      .filter(item => item.cb_wants_to_sell < 0)
      .reduce((sum, item) => sum + item.cb_wants_to_sell, 0)
  );

  const price_to_pay = data.reduce((sum, item) => sum + item.total_value, 0);

  const totalContribution = data
    .filter(item => item.cb_consumed !== null)
    .reduce((sum, item) => sum + parseFloat(item.cb_consumed || 0), 0);

  const totalDeficit = Math.abs(
    data
      .filter(item => item.cb_wants_to_sell < 0)
      .reduce((sum, item) => sum + parseFloat(item.cb_wants_to_sell || 0), 0)
  );

  const contributionOffset = ((totalContribution - totalDeficit) / 10 ** 6).toFixed(4);
  const [mynewdata, setmynewdata] = useState({});
  // useEffect(() => {
  //   console.log("new", mynewdata)
  //   if (contributionOffset == 0) {
  //     dispatch(updateManualPriceBreakDown(mynewdata));
  //   }
  // }, [contributionOffset, mynewdata])

  const checkContributionForPool = () => {
    // console.log("totalContribution in", data)
    let updatedData = data.map(item => {
      return {
        ...item,
        cb_consumed: item.cb_wants_to_sell >= 0 ? parseFloat(contributionMap[item.token_id]) : null,
      };
    });

    // console.log("totalContribution in updated", updatedData)


    // Sum of contributions (cb_consumed) for surplus records
    const totalContribution = updatedData
      .filter(item => item.cb_consumed !== null)
      .reduce((sum, item) => sum + parseFloat(item.cb_consumed || 0), 0);

    const totalDeficit = Math.abs(
      data
        .filter(item => item.cb_wants_to_sell < 0)
        .reduce((sum, item) => sum + parseFloat(item.cb_wants_to_sell || 0), 0)
    );
    // console.log("totalContribution", totalContribution, totalDeficit)
    if ((totalContribution / 10 ** 6)?.toFixed(4) > (totalDeficit / 10 ** 6)?.toFixed(4)) {
      notification.warning({
        message: "Insufficient Contribution",
        description: "Total contribution is more than required for the pool.",
        icon: <AlignLeftOutlined style={{ color: "#faad14" }} />,
        placement: "topRight",
      });

    }
    else if ((totalContribution / 10 ** 6)?.toFixed(4) < (totalDeficit / 10 ** 6)?.toFixed(4)) {
      notification.warning({
        message: "Insufficient Contribution",
        description: "Total contribution is less than required for the pool.",
        icon: <AlignLeftOutlined style={{ color: "#faad14" }} />,
        placement: "topRight",
      });

    }
    else if ((totalContribution / 10 ** 6)?.toFixed(4) == (totalDeficit / 10 ** 6)?.toFixed(4)) {
      setHasEdited(false);

    }

    const lastDictionary = getLastDictionary(manualPriceBreakDown);
    const finalData = [...updatedData];

    const manualPoolRedPayload = {
      data: finalData,
      pool_id: redirectedPoolId || "",
      total_surplus_value: lastDictionary.total_surplus_value,
    }

    dispatch(updateManualPriceBreakDownData([...updatedData, lastDictionary]));
    setmynewdata(manualPoolRedPayload);
    updatedData = updatedData.map(item => ({
      ...item,
    }));

  };

  useEffect(()=>{
    if(contributionOffset==0){
      dispatch(updateManualPriceBreakDown(mynewdata));


    }
  },[contributionOffset,hasEdited])

  const savePool = async () => {

    await handleInitiatePool(data);
    navigate('/poolingHistory');
  }


  return (
    <Modal
      title={
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start", paddingRight: "1.2vw" }}>
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "flex-start", paddingRight: "1.2vw" }}>
            <span>Manual Pooling</span>
            <div style={{ marginBottom: 16, fontWeight: 500 }}>This pools tailored by admin to meet the specific requirements of the CB.</div>
          </div>
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start", paddingRight: "1.2vw" }}>
            <div
              className="contribution-difference-status-box"
              style={{
                backgroundColor:
                  contributionOffset > 0
                    ? "#0CC87633"
                    : "#FB2F2F33",
                padding: "4px 8px",
                borderRadius: 4,
              }}
            >
              <span style={{ fontSize: "15px", display: "block", fontWeight: "bold" }}>Contribution Offset</span>
              <span
                style={{
                  color:
                    contributionOffset > 0
                      ? "#0CC876"
                      : "#FB2F2F",
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                <img
                  style={{ width: "3vh", display: "inline-block" }}
                  src={
                    contributionOffset > 0
                      ? cbGreenIcon
                      : cbRedIcon
                  }
                  alt="cb icon"
                />
                {contributionOffset} CB
              </span>
            </div>
          </div>
        </div>
      }
      visible={isModalVisible}
      onCancel={handleCancel}
      footer={null}
      width={1100}
      className="generated-pool-modal full-screen-modal"
      closeIcon={<CloseOutlined style={{ fontSize: '20px', fontWeight: 'bold', color: 'red', maxHeight: "100vh" }} />}

    >
      {/* {console.log("manualPriceBreakDown", manualPriceBreakDown)} */}
      {manualPriceBreakDown.length != 0 ?
        <div>
          <div className='generated-pool'>
            <div className='generated-header'>
              <div className="generated-filter-buttons">
                <Button className={`generated-filter-button ${filterType == "all" ? "active" : ""}`} onClick={() => handleFilterChange('all')}>All Vessels</Button>
                <Button className={`generated-filter-button surplus-button ${filterType == "surplus" ? "active" : ""}`} onClick={() => handleFilterChange('surplus')}>Surplus Vessels</Button>
                <Button className={`generated-filter-button deficit-button ${filterType == "deficit" ? "active" : ""}`} onClick={() => handleFilterChange('deficit')}>Deficit Vessels</Button>
              </div>
              <div className="generated-price-details">
                <div className="generated-status-box" style={{ backgroundColor: getLastDictionary(manualPriceBreakDown)?.total_surplus_cb / (10 ** 6) > 0 ? "#0CC87633" : "#FB2F2F33" }}>
                  <span style={{ fontSize: "15px" }}>Total Surplus CB</span>
                  <span style={{ color: getLastDictionary(manualPriceBreakDown)?.total_surplus_cb > 0 ? "#0CC876" : "#FB2F2F" }}><img style={{ width: '3vh', justifyContent: 'center' }} src={getLastDictionary(manualPriceBreakDown)?.total_surplus_cb / (10 ** 6) > 0 ? cbGreenIcon : cbRedIcon} alt="cb icon" />{Math.abs(getLastDictionary(manualPriceBreakDown)?.total_surplus_cb / (10 ** 6)).toFixed(6)} CB</span>
                </div>
                <div className="generated-status-box" style={{ backgroundColor: getLastDictionary(manualPriceBreakDown)?.total_deficit_cb / (10 ** 6) > 0 ? "#0CC87633" : "#FB2F2F33" }}>
                  <span style={{ fontSize: "15px" }}>Total Deficit CB</span>
                  <span style={{ color: getLastDictionary(manualPriceBreakDown)?.total_deficit_cb > 0 ? "#0CC876" : "#FB2F2F" }}><img style={{ width: '3vh', justifyContent: 'center' }} src={getLastDictionary(manualPriceBreakDown)?.total_deficit_cb / (10 ** 6) > 0 ? cbGreenIcon : cbRedIcon} alt="cb icon" />{Math.abs(getLastDictionary(manualPriceBreakDown)?.total_deficit_cb / (10 ** 6)).toFixed(6)} CB</span>
                </div>
                <div className="generated-status-box" style={{ backgroundColor: getLastDictionary(manualPriceBreakDown)?.remaining_cb / (10 ** 6) > 0 ? "#0CC87633" : "#FB2F2F33" }}>
                  <span style={{ fontSize: "15px" }}>Remaining CB</span>
                  <span style={{ color: getLastDictionary(manualPriceBreakDown)?.remaining_cb > 0 ? "#0CC876" : "#FB2F2F" }}><img style={{ width: '3vh', justifyContent: 'center' }} src={getLastDictionary(manualPriceBreakDown)?.remaining_cb / (10 ** 6) > 0 ? cbGreenIcon : cbRedIcon} alt="cb icon" />{Math.abs(getLastDictionary(manualPriceBreakDown)?.remaining_cb / (10 ** 6)).toFixed(6)} CB</span>
                </div>
              </div>
            </div>
            <Table className="generated-vessels-table" columns={columns} pagination={false} style={{ width: "100vw" }} scroll={{ y: scrollHeight }} bordered dataSource={data} rowKey="token_id" />
            <div
              className='manual-generated-pool-footer'
            >
              <div className='footer-title'><img width={14} src={infoIcon} />To continue with this pool, {!hasEdited ? "select Finalize & Proceed." : "select Check Contribution & Proceed to check the offset of Distribution at top right corner"}</div>
              {!hasEdited ? <Button className='finalize-button'
                onClick={savePool}
              >{`Finalize & Proceed`}<img style={{ marginLeft: '0.5vw' }} src={vectorrightIcon} /><img src={vectorrightIcon} /></Button>
                : <Button className='finalize-button' onClick={checkContributionForPool}>{`Check Contribution & Proceed`}</Button>}

            </div>
          </div>
        </div>

        : <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80vh", fontSize: "24px", fontWeight: "500", textAlign: "center" }}>
          Pool was not created as no suitable matches were found.
        </div>}

      {/* <ConfirmationModal
        isVisible={isFinalModalVisible}
        onCancel={handleCloseModal}
        onConfirm={handleConfirm}
        poolClosedAt={pool_closed_At}
        priceToPay={price_to_pay}
      /> */}
    </Modal>
  );
};

export default DistributionModal;